<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="headline dialog-header"
          ><slot name="headline"></slot
        ></v-card-title>
        <!-- <p class="headline pa-2 warning-title"><slot name="headline"></slot></p> -->
        <v-card-text><slot name="body"></slot></v-card-text>
        <v-card-actions>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["dialog"]
};
</script>

<style scoped>
.dialog-header {
  word-break: break-word !important;
}
</style>
